/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// Loaded before CoreUI app.js
import '../bootstrap';
import 'pace';
import Sortable from 'sortablejs';
import '../../vendor/multiselect/multi-select';
import '../../vendor/tagsinput/bootstrap-tagsinput';
import '../plugins';

window.Sortable = Sortable;

export const randomStr = (n = 10) => {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < n; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
};

export const bootboxConfirm = (title, message, cb) => {
    bootbox.confirm({
        title,
        message,
        buttons: {
            confirm: {
                label: '<i class="fa fa-check"></i> Yes',
                className: 'btn-primary'
            },
            cancel: {
                label: '<i class="fa fa-times"></i> No',
                className: 'btn-danger'
            }
        },
        callback: function (result) {
            if (result) {
                cb();
            }
        }
    });
};

export const roundNumber = (number, decimal = 2) => {
    if (number % 1 === 0) return number;

    const power = Math.pow(10, decimal);

    return Math.round(number * power) / power;
};

export const parseQueryString = function() {
    const parsedParameters = {},
        uriParameters = location.search.substr(1).split('&');

    for (var i = 0; i < uriParameters.length; i++) {
        const parameter = uriParameters[i].split('=');
        parsedParameters[parameter[0]] = decodeURIComponent(parameter[1]);
    }

    delete parsedParameters[""];

    return parsedParameters;
};

export const swalError = (message) => {
    Swal.fire({
        title: 'Error',
        text: message,
        icon: 'error',
        toast: true,
        position: "top-right",
        timer: 5000,
        showConfirmButton: false,
    });
};

export const swalSuccess = (message) => {
    Swal.fire({
        title: 'Success',
        text: message,
        icon: 'success',
        toast: true,
        position: "top-right",
        timer: 5000,
        showConfirmButton: false,
    });
};

export const getPictureUrl = (pictures) => {
    if (pictures.length > 0) {
        return `/storage/${pictures[0]}`;
    }

    return '/img/backend/image.png';
};
